import { c as _c } from "react/compiler-runtime";
import { getOrgArtifactsByArtifactIdVersionsOptions } from '@onefootprint/fetch-dashboard';
import { useQuery } from '@tanstack/react-query';

// TODO: paginate — currently capped at the first page (pageSize=100).
// Switch to infinite scroll once an artifact can plausibly exceed this.
const useArtifactVersions = artifactId => {
  const $ = _c(5);
  const t0 = artifactId ?? "";
  let t1;
  if ($[0] !== t0) {
    t1 = getOrgArtifactsByArtifactIdVersionsOptions({
      path: {
        artifactId: t0
      },
      query: {
        pageSize: 100
      }
    });
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = !!artifactId;
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = {
      ...t1,
      enabled: t2,
      select: _temp2
    };
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return useQuery(t3);
};
export default useArtifactVersions;
function _temp(a, b) {
  return b.versionNumber - a.versionNumber;
}
function _temp2(data) {
  return [...data.data].sort(_temp);
}